import React from 'react'

const ProgressBar = (props) => {
  const { bgcolor, pgcolor, completed } = props

  const containerStyles = {
    height: 20,
    width: '100%',
    backgroundColor: bgcolor || '#e0e0de',
    borderRadius: 50,
    // margin: 10,
  }

  const fillerStyles = {
    height: '100%',
    width: `${completed}%`,
    backgroundColor: pgcolor || '#2da888',
    borderRadius: 'inherit',
    textAlign: 'right',
  }

  const labelStyles = {
    padding: 5,
    color: 'white',
    fontWeight: 'bold',
  }

  return (
    <div style={containerStyles}>
      <div style={fillerStyles}>
        <span style={labelStyles}>{`${completed}%`}</span>
      </div>
    </div>
  )
}

export default ProgressBar
